// 司机优质服务

import { qualityServiceInfoApi } from '@/pages/order-center/apis';
import { log } from '@/utils/log';
import { useDebounceFn } from 'ahooks';
import { useEffect, useState } from 'react';
import { useModel, useRequest } from 'umi';

export default function OrderCenterSameCityQualityService() {
  const [serviceList, setServiceList] = useState<string[]>([]);
  const [showQualityService, setShowQualityService] = useState(false);
  const [driverService, setDriverService] = useState<string[]>([]);
  const { selectedCity } = useModel('order-center-same-city-shipping-city');
  const { selectedVehicle, cityInfo } = useModel(
    'order-center-same-city-car-model-select'
  );
  const qualityServiceRequest = useRequest(qualityServiceInfoApi, {
    manual: true,
    onSuccess: (data) => {
      const {
        qualityServiceIncentiveFlag,
        qualityServiceTips,
        confirmOrderPageTips,
      } = data || {};
      setShowQualityService(qualityServiceIncentiveFlag === 1);
      setServiceList(qualityServiceTips || []);
      setDriverService((confirmOrderPageTips || '').split('、'));
    },
  });
  const { run } = useDebounceFn(
    (params) => {
      qualityServiceRequest.run(params);
    },
    { wait: 800 }
  );
  useEffect(() => {
    if (selectedCity !== cityInfo.cityId) {
      log.log('城市接口数据未更新，不执行qualityServiceInfoApi', `${selectedCity}-${cityInfo.cityId}`,);
      return;
    }
    if (selectedCity) {
      run({
        city_id: selectedCity,
        standard_order_vehicle_id: selectedVehicle.standardOrderVehicleId,
      });
    }
  }, [selectedCity, run, selectedVehicle.standardOrderVehicleId, cityInfo.cityId]);
  return {
    serviceList,
    showQualityService,
    driverService,
  };
}
